import { useCallback, useState } from 'react';
export default function useLocalStorage(key) {
    var _a = useState(window.localStorage.getItem(key)), value = _a[0], setValue = _a[1];
    var saveValue = useCallback(function (data) {
        window.localStorage.setItem(key, data);
        setValue(data);
    }, [key]);
    return [value, saveValue];
}
